import React from "react";

const STATUS_MAP = {
  "in progress": "in-progress",
  "in-progress": "in-progress",
  in_progress: "in-progress",
  open: "in-progress",
  active: "in-progress",
  assigned: "assigned",
  scheduled: "scheduled",
  pending: "pending",
  warning: "warning",
  needs_review: "warning",
  "needs review": "warning",
  info: "info",
  paused: "paused",
  overdue: "overdue",
  complete: "complete",
  completed: "completed",
  approved: "success",
  resolved: "success",
  success: "success",
  blocked: "error",
  denied: "error",
  disputed: "error",
  error: "error",
  unassigned: "unassigned",
};

function normalizeStatus(status) {
  if (!status) {
    return "default";
  }

  const raw = String(status).trim().toLowerCase();
  if (STATUS_MAP[raw]) return STATUS_MAP[raw];
  if (raw.includes("warning") || raw.includes("review")) return "warning";
  if (raw.includes("error") || raw.includes("denied") || raw.includes("blocked")) return "error";
  if (raw.includes("success") || raw.includes("approve") || raw.includes("resolve")) return "success";
  if (raw.includes("schedule")) return "scheduled";
  if (raw.includes("progress") || raw.includes("active") || raw.includes("open")) return "in-progress";
  return "default";
}

export default function StatusBadge({ status, label }) {
  const normalized = normalizeStatus(status);
  const text = label || status || "Status";

  return <span className={`gg-status gg-status--${normalized}`}>{text}</span>;
}
